//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

import productAudioPlayerMixin from '@motionelements/core/src/components/mixins/productAudioPlayer.mixin.js';
import PlayBtn from '@motionelements/core/src/components/product-card/sections/actions/ProductButtonPlay.vue';
import ProductInfoItemName from '@motionelements/core/src/components/product-card/sections/info/audio/ProductInfoItemName.vue';
import Actions from '@motionelements/core/src/components/product-card/sections/ProductCardActionsAudio.vue';
import MediaTypeInfoFull from '@motionelements/core/src/components/product-card/sections/ProductCardMediaTypeInfoFullAudio.vue';
import ProductCardPreviewAudio from '@motionelements/core/src/components/product-card/sections/ProductCardPreviewAudio.vue';

export default {
  name: 'product-card-audio',
  mixins: [productAudioPlayerMixin],
  components: {
    PlayBtn,
    ProductInfoItemName,
    ProductCardPreviewAudio,
    MediaTypeInfoFull,
    Actions,

    StemsToggle: () => import('@motionelements/core/src/components/product-card/sections/actions/ProductButtonStemsToggle.vue'),
  },
  data() {
    return {
      isHovering: false,
    };
  },
  props: {
    product: Object,

    // Actions
    showFavorite: {
      type: Boolean,
      default: true,
    },
    showSimilar: {
      type: Boolean,
      default: true,
    },
    showDownloadSample: {
      type: Boolean,
      default: true,
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    showCategory: {
      type: Boolean,
      default: true,
    },
    showStemsToggle: {
      type: Boolean,
      default: false,
    },
    showArtistName: {
      type: Boolean,
      default: true,
    },
    showTempo: {
      type: Boolean,
      default: true,
    },
    //
    isStemCard: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
    element() {
      return this.product;
    },
    details() {
      return _.get(this.element, 'mediaTypeDetails', _.get(this.element, 'media_type_details'));
      // return this.element.mediaTypeDetails;
    },
    isElement() {
      return _.get(this.product, 'object') === 'element';
    },
    linkUrl() {
      let url = _.get(this.options, 'linkUrl') || _.get(this.product, 'html.url');

      // add in query_id / position for tracking
      if (this.searchQueryId) {
        url += `?query_id=${this.metadata.queryId}`;
        if (_.get(this.metadata, 'position')) {
          url += `&position=${this.metadata.position}`;
        }
      }

      return url;
    },
    hasStems() {
      return true;
    },
    showToggle() {
      return this.showStemsToggle && this.hasStems;
    },
  },
  methods: {
    emitProductEvent(eventName) {
      this.$bus.$emit(eventName, {
        product: {
          ...this.product,
          ...{ metadata: this.metadata },
        },
      }); // send event to mixins product-events
    },
    onClickActionButton(action) {
      switch (action) {
        case 'view':
          this.viewProduct();
          break;
        case 'similar':
          this.emitProductEvent('product-similar-search');
          break;
        case 'favorite':
          this.emitProductEvent('product-favorite');
          break;
        case 'pin':
          this.emitProductEvent('product-pin');
          break;
        case 'sample-download':
          this.emitProductEvent('product-sample-download');
          break;
        default:
      }
    },
    viewProduct() {
      this.$store.commit('product/setCurrentElement', this.element);
    },
  },
};
